module.exports = __webpack_public_path__ + "img/apple-music.5eb1c2f8.png";